import React, { useState, useEffect } from 'react';
import { Button, Card } from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { useTranslation } from 'react-i18next';
import { getSingleConfig, getImageUrlOfConfig } from 'y4/Falcon';
import _ from 'lodash';

const PurchaseCard = () => {
  const [show, setShow] = useState(true);
  const [config, setConfig] = useState(null);
  const { t } = useTranslation('menu');

  useEffect(() => {
    getSingleConfig('MenuNotification').then(c => {
      setConfig(c);
    });
  }, []);

  const image = getImageUrlOfConfig(config);

  return (
    show &&
    config && (
      <div className="settings my-3">
        <Card className="p-0 bg-white rounded-2 position-relative">
          <div
            className="position-absolute"
            style={{ right: '3px', top: '3px' }}
          >
            <FalconCloseButton
              size="sm"
              noOutline
              onClick={() => setShow(false)}
            />
          </div>
          <Card.Body className="text-center">
            <img src={image} alt="" width={80} />
            <p
              className="fs--2 mt-2"
              dangerouslySetInnerHTML={{
                __html: _.startsWith(config.caption, '__')
                  ? t(config.caption.slice(2))
                  : config.caption
              }}
            ></p>
            <div className="d-grid gap-2">
              <Button
                as={'a'}
                href={config.url}
                target={config.urlTarget}
                size="sm"
                className="btn-purchase"
              >
                {_.startsWith(config.title, '__')
                  ? t(config.title.slice(2))
                  : config.title}
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    )
  );
};

export default PurchaseCard;
